<template>
  <div v-wechat-title="title" style="height:100%">
    {{title}}-{{this.$route.query.surgery_id}}
  </div>
</template>
<script>
export default {
    name: `SecurityCheck`,
    props: {

    },
    data() {
        return {
            title: `安全核查`
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Surgery/SecurityCheck/Index.vue